import sunrays from './sunrays'

window.addEventListener('DOMContentLoaded', function () {
   (function ($) {
      window.sunrays = sunrays
		sunrays.init($)
	})(jQuery)
})
